import { defineStore } from 'pinia';

export type AnimationMode = 'stream' | 'lines'
export type SearchMode = 'auto' | 'fast' | 'expert'

export const useSettingStore = defineStore('setting', {
  state: () => ({
    reload: false,
    animationMode: 'stream' as AnimationMode,
    // Persisted search mode preference (lowercase)
    searchMode: ((process.client ? (localStorage.getItem('kr.searchMode') as SearchMode | null) : null) || 'fast') as SearchMode,
  }),
  actions: {
    startReload() {
      this.reload = true;
    },
    finishReload() {
      this.reload = false;
    },
    setAnimationMode(mode: AnimationMode) {
      this.animationMode = mode
    },
    setSearchMode(mode: SearchMode) {
      this.searchMode = mode
      if (process.client) localStorage.setItem('kr.searchMode', mode)
    }
  },
});
